/*=============================================== ButtonPage ===============================================*/

import { Button, Flexbox } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps, propAllLinks } from "data"

const ButtonPage = () => {
    const items: ItemType[] = [
        {
            title: "Plain",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <Button variant="plain" color="primary">
                        Button
                    </Button>
                    <Button variant="plain" color="secondary">
                        Button
                    </Button>
                    <Button variant="plain" color="success">
                        Button
                    </Button>
                    <Button variant="plain" color="danger">
                        Button
                    </Button>
                    <Button variant="plain" color="warning">
                        Button
                    </Button>
                    <Button variant="plain" color="white">
                        Button
                    </Button>
                    <Button variant="plain" color="font">
                        Button
                    </Button>
                    <Button variant="plain" color="background">
                        Button
                    </Button>
                    <Button variant="plain" color="primary" disabled>
                        Button
                    </Button>
                </Flexbox>
            ),
            code: '<Button variant="plain" color="primary">Button</Button>\n<Button variant="plain" color="secondary">Button</Button>\n<Button variant="plain" color="success">Button</Button>\n<Button variant="plain" color="danger">Button</Button>\n<Button variant="plain" color="warning">Button</Button>\n<Button variant="plain" color="white">Button</Button>\n<Button variant="plain" color="font">Button</Button>\n<Button variant="plain" color="background">Button</Button>\n<Button variant="plain" color="primary" disabled>Button</Button>',
        },
        {
            title: "Transparent",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <Button variant="transparent" color="primary">
                        Button
                    </Button>
                    <Button variant="transparent" color="secondary">
                        Button
                    </Button>
                    <Button variant="transparent" color="success">
                        Button
                    </Button>
                    <Button variant="transparent" color="danger">
                        Button
                    </Button>
                    <Button variant="transparent" color="warning">
                        Button
                    </Button>
                    <Button variant="transparent" color="white">
                        Button
                    </Button>
                    <Button variant="transparent" color="font">
                        Button
                    </Button>
                    <Button variant="transparent" color="background">
                        Button
                    </Button>
                    <Button variant="transparent" color="primary" disabled>
                        Button
                    </Button>
                </Flexbox>
            ),
            code: '<Button variant="transparent" color="primary">Button</Button>\n<Button variant="transparent" color="secondary">Button</Button>\n<Button variant="transparent" color="success">Button</Button>\n<Button variant="transparent" color="danger">Button</Button>\n<Button variant="transparent" color="warning">Button</Button>\n<Button variant="transparent" color="white">Button</Button>\n<Button variant="transparent" color="font">Button</Button>\n<Button variant="transparent" color="background">Button</Button>\n<Button variant="transparent" color="primary" disabled>Button</Button>',
        },
        {
            title: "Ghost",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <Button variant="ghost" color="primary">
                        Button
                    </Button>
                    <Button variant="ghost" color="secondary">
                        Button
                    </Button>
                    <Button variant="ghost" color="success">
                        Button
                    </Button>
                    <Button variant="ghost" color="danger">
                        Button
                    </Button>
                    <Button variant="ghost" color="warning">
                        Button
                    </Button>
                    <Button variant="ghost" color="white">
                        Button
                    </Button>
                    <Button variant="ghost" color="font">
                        Button
                    </Button>
                    <Button variant="ghost" color="background">
                        Button
                    </Button>
                    <Button variant="ghost" color="primary" disabled>
                        Button
                    </Button>
                </Flexbox>
            ),
            code: '<Button variant="ghost" color="primary">Button</Button>\n<Button variant="ghost" color="secondary">Button</Button>\n<Button variant="ghost" color="success">Button</Button>\n<Button variant="ghost" color="danger">Button</Button>\n<Button variant="ghost" color="warning">Button</Button>\n<Button variant="ghost" color="white">Button</Button>\n<Button variant="ghost" color="font">Button</Button>\n<Button variant="ghost" color="background">Button</Button>\n<Button variant="ghost" color="primary" disabled>Button</Button>',
        },
        {
            title: "Outline",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <Button variant="outline" color="primary">
                        Button
                    </Button>
                    <Button variant="outline" color="secondary">
                        Button
                    </Button>
                    <Button variant="outline" color="success">
                        Button
                    </Button>
                    <Button variant="outline" color="danger">
                        Button
                    </Button>
                    <Button variant="outline" color="warning">
                        Button
                    </Button>
                    <Button variant="outline" color="white">
                        Button
                    </Button>
                    <Button variant="outline" color="font">
                        Button
                    </Button>
                    <Button variant="outline" color="background">
                        Button
                    </Button>
                    <Button variant="outline" color="primary" disabled>
                        Button
                    </Button>
                </Flexbox>
            ),
            code: '<Button variant="outline" color="primary">Button</Button>\n<Button variant="outline" color="secondary">Button</Button>\n<Button variant="outline" color="success">Button</Button>\n<Button variant="outline" color="danger">Button</Button>\n<Button variant="outline" color="warning">Button</Button>\n<Button variant="outline" color="white">Button</Button>\n<Button variant="outline" color="font">Button</Button>\n<Button variant="outline" color="background">Button</Button>\n<Button variant="outline" color="primary" disabled>Button</Button>',
        },
        {
            title: "Small",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <Button size="small" color="primary">
                        Button
                    </Button>
                    <Button size="small" color="secondary">
                        Button
                    </Button>
                    <Button size="small" color="success">
                        Button
                    </Button>
                    <Button size="small" color="danger">
                        Button
                    </Button>
                    <Button size="small" color="warning">
                        Button
                    </Button>
                    <Button size="small" color="white">
                        Button
                    </Button>
                    <Button size="small" color="font">
                        Button
                    </Button>
                    <Button size="small" color="background">
                        Button
                    </Button>
                </Flexbox>
            ),
            code: '<Button size="small" color="primary">Button</Button>\n<Button size="small" color="secondary">Button</Button>\n<Button size="small" color="success">Button</Button>\n<Button size="small" color="danger">Button</Button>\n<Button size="small" color="warning">Button</Button>\n<Button size="small" color="white">Button</Button>\n<Button size="small" color="font">Button</Button>\n<Button size="small" color="background">Button</Button>',
        },
        {
            title: "With icon",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <Button
                        variant="plain"
                        color="primary"
                        icons={{ left: "mail" }}
                    >
                        Button
                    </Button>
                    <Button
                        variant="transparent"
                        color="secondary"
                        icons={{ right: "chevron-down" }}
                    >
                        Button
                    </Button>
                </Flexbox>
            ),
            code: '<Button variant="plain" color="primary" icons={{ left: "mail" }}>Button</Button>\n<Button variant="transparent" color="secondary" icons={{ right: "chevron-down" }}>Button</Button>',
        },
        {
            title: "With link",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <Button variant="plain" color="primary" to="/">
                        Button
                    </Button>
                    <Button
                        variant="ghost"
                        color="secondary"
                        href="https://google.com"
                    >
                        Button
                    </Button>
                </Flexbox>
            ),
            code: '<Button variant="plain" color="primary" to="/">Button</Button>\n<Button variant="ghost" color="secondary" href="https://google.com">Button</Button>',
        },
        {
            title: "Loading",
            content: (
                <Flexbox gap="xs" flexWrap="wrap">
                    <Button isLoading>Button</Button>
                </Flexbox>
            ),
            code: "<Button isLoading>Button</Button>",
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "variant",
            type: "string",
            possible: ["plain", "transparent", "outline", "ghost"],
            default: "plain",
        },
        {
            subtitle: "color",
            type: "string",
            possible: commonProps.colorsHover,
            default: "primary",
        },
        {
            subtitle: "size",
            type: "string",
            possible: ["default", "small"],
            default: "default",
        },
        ...propAllLinks,
        {
            subtitle: "isLoading",
            type: "boolean",
        },
        {
            subtitle: "loaderVariant",
            intro: (
                <>
                    Only if <code>isLoading</code> is defined.
                </>
            ),
            type: "number",
            possible: [1, 2, 3, 4],
            default: 1,
        },
        {
            subtitle: "noPadding",
            intro: (
                <>
                    Only if <code>variant</code> is set to{" "}
                    <code>transparent</code>.
                </>
            ),
            type: "boolean",
        },
        "separator",
        {
            subtitle: "icons",
            type: "object",
        },
        {
            title: (
                <>
                    <code>icons</code> object
                </>
            ),
            subtitle: "left",
            intro: commonProps.addIconCapital,
            type: "string",
        },
        {
            subtitle: "right",
            type: "string",
        },
        {
            subtitle: "size",
            intro: (
                <>
                    Only if one of the <code>icons</code> is set.
                </>
            ),
            type: "number",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default ButtonPage
